var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-mask-field',_vm._g(_vm._b({attrs:{"mask":"##.###.###/####-##"}},'app-mask-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }